import { routes } from 'commons/constants/routes'
import { IconSize } from 'ui/components/Icon'
import { Link } from 'ui/components/Link'
import { TextMask } from 'ui/components/TextMask'
import { DocumentSubject } from '~bank-documents/types/documentList'

export const getSubjectType = (subject: DocumentSubject) => {
  switch (subject.type) {
    case 'company':
      return (
        <>
          <div>{subject.label}</div>
          <Link to={routes.bank.relationships.details} params={{ id: subject.id.toString() }}>
            {subject.name}
          </Link>
        </>
      )
    case 'license':
      return (
        <>
          <div>{subject.label}</div>
          <Link to="/licenses/$licenseId" params={{ licenseId: subject.id.toString() }}>
            {subject.name}
          </Link>
        </>
      )
    case 'bank_account':
      return (
        <>
          <div>{subject.label}</div>
          <Link to="/bank-accounts/$bankAccountId" params={{ bankAccountId: subject.id.toString() }}>
            <TextMask isBankAccount text={subject.name} iconSize={IconSize.XS} />
          </Link>
        </>
      )
    case 'contact':
      return (
        <>
          <div>{subject.label}</div>
          <Link to="/contacts/$contactId" params={{ contactId: subject.id.toString() }}>
            {subject.name}
          </Link>
        </>
      )
    default:
      return null
  }
}
